enum CertificateSettingsDialogFields {
	KEYSTORE_PASSWORD = "keystore_password",
	CERTIFICATE_PASSWORD = "certificate_password",
	HINTS = "hints"
}

export default CertificateSettingsDialogFields;